(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('modelService', modelService);

    modelService.$inject = ['$http', '$q', '$log', 'poller', 'modelProcessingService'];

    function modelService($http, $q, $log, poller, modelProcessingService) {
        var baseUrl = '/models/';

        return {
            createModel: createModel,

            getModelInfo: getModelInfo,
            getModelProductTemplateId: getModelProductTemplateId,

            acceptRepair: acceptRepair,
            declineRepair: declineRepair
        };
        
        function createModel(fileId, originalFileName, measureUnit, productTemplateId, canceler) {
            var params = {
                FileID: fileId,
                OriginalFileName: originalFileName,
                MeasureUnits: measureUnit,
                ProductTemplateID: productTemplateId
            };

            var promise = $http.post(baseUrl + "create", params, {
                canceler: canceler
            })
                .then(function (response) {
                    return response.data;
                });

            return promise;
        }

        function getModelInfo(modelId, canceler) {
            return $http.get(baseUrl + modelId + "/info", {
                canceler: canceler
            })
                .then(function (response) {
                    var model = response.data;

                    model.status = modelProcessingService.extendStatusInfo(model.status);
                    model.result = modelProcessingService.extendResultInfo(model.result);

                    model.isNeedToApproveRepairModel = isNeedToApproveRepairModel;

                    return model;
                })
                .catch(function (response) {
                    if (response.status === 404) {
                        return $q.reject("Model not found");
                    }

                    return $q.reject(response);
                });
        }


        function getModelProductTemplateId(modelId, canceler) {
            return $http.get(baseUrl + modelId + "/product-template", {
                canceler: canceler
            })
                .then(function (response) {
                    return response.data;
                })
                .catch(function (response) {
                    if (response.status === 404) {
                        return $q.reject("Model not found");
                    }

                    return $q.reject(response);
                });
        }

        function acceptRepair(modelId, canceler) {
            var promise = $http.post(baseUrl + modelId + "/accept-repair", null, {
                canceler: canceler
            })
                .then(function (response) {
                    return response.data;
                })
                .catch(handleError);

            return promise;
        }

        function declineRepair(modelId, canceler) {
            var promise = $http.post(baseUrl + modelId + "/decline-repair", null, {
                canceler: canceler
            })
                .then(function (response) {
                    return response.data;
                })
                .catch(handleError);

            return promise;
        }

        function handleError(response) {
            if (response.status === 404) {
                return $q.reject("Model not found");
            }

            if (response.status === 409) {
                return $q.reject("Model already has repair results");
            }

            return $q.reject(response);
        }

        function isNeedToApproveRepairModel() {
            return this.result.isSucceeded() && this.isFixedByV3 && !this.isFixV3ResultsApproved;
        }
    }
}());